<div fxLayout="column" fxLayoutGap="80px" fxLayoutGap.lt-md="20px">
    <swiper class="swiper-container head" [config]="config">
        <div style="cursor:'pointer'; width: 100%;" class="swiper-slide" *ngFor="let banner of bannerHome">

            <div class="head" fxLayoutAlign="center center"
                style="background-image: url('{{banner.pathImagem}}');" (click)="abrirLink(banner.link)">
                <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="50px" fxLayoutGap.lt-md="20px">
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <span class="title">
                            {{banner.titulo}}
                        </span>

                        <span class="subtitle">
                            {{banner.subTitulo}}
                        </span>
                    </div>
                </div>

                <div>
                    <i class="fas fa-arrow-down"></i>
                </div>
            </div>
        </div>
    </swiper>

    <div class="margin presentation" id="animateSeccion">
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="60px" fxLayoutGap.lt-md="30px">
            <div fxFlex="50" fxLayout="column" fxLayoutGap="50px" fxLayoutGap.lt-md="20px"
                [ngStyle.lt-md]="{'padding-top': '20px'}" [ngStyle.gt-sm]="{'padding-top': '40px'}">
                <span class="presentation-title">
                    {{data.secaoComoFunciona.titulo}}
                </span>

                <span class="presentation-subtitle">
                    {{data.secaoComoFunciona.conteudo}}
                </span>

                <div class="btn-como-funciona" fxLayout="row" fxLayoutAlign="center center">
                    <app-button [txt]="'CLIQUE PARA SABER COMO FUNCIONA'" routerLink="/sobre"
                        [btnClass]="'btn-blue-filled-no-animation presentation-btn-w'" [fontFamily]="'Oswald'">
                    </app-button>
                </div>
            </div>

            <div fxFlex="50" *ngIf="data.secaoComoFunciona.path">
                <img class="presentation-img" src="{{storageUrl + data.secaoComoFunciona.path}}">
            </div>
        </div>
    </div>

    <div fxLayout="column">
        <div class="pillar">
            <div fxLayout="column" fxLayoutGap="25px" fxLayoutAlign="center center">
                <div fxLayout="column">
                    <span class="pillar-title">
                        {{data.secaoPilares.titulo}}
                    </span>
                    <span class="pillar-title-small">
                        {{data.secaoPilares.subTitulo}}
                    </span>
                </div>

                <span class="pillar-subtitle">
                    {{data.secaoPilares.conteudo}}
                </span>

                <app-pillar-list></app-pillar-list>
            </div>
        </div>

        <app-cadastre-se-stripe [title]="'Visão estratégica, Conhecimento, Protagonismo.'"></app-cadastre-se-stripe>

        <app-product-type-option></app-product-type-option>
    </div>

    <div class="margin" *ngIf="data">

        <div fxLayout="column" fxLayoutGap="55px" fxLayoutGap.lt-md="20px">
            <div class="conteudo-a-vista">
                <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap.lt-xl="10px">
                    <span class="title">{{data.secaoArtigos.titulo}}</span>

                    <div fxLayout="column" class="description-width">
                        <span class="description">{{data.secaoArtigos.conteudo}}</span>
                    </div>
                </div>
            </div>

            <app-article-list [nRegistros]="3"></app-article-list>

        </div>
    </div>

    <div></div>

    <app-video-carrousel *ngIf="videoList.length > 0" [videoList]="videoList"></app-video-carrousel>
</div>